import api from './api';

export async function createCashfreeOrder(orderId, gatewayId) {
  if (!String(orderId || '').trim() || !Number.isInteger(Number(gatewayId)) || Number(gatewayId) <= 0) {
    throw new Error('Select a valid order and payment method.');
  }
  const response = await api.post('/cashfree/create-order', {
    vk_order_id: orderId, payment_gateway_id: Number(gatewayId), platform: 'web',
  });
  const body = response?.data;
  if (body?.error || Number(body?.code) !== 200) {
    throw new Error(body?.message || 'Unable to start Cashfree checkout.');
  }
  const data = body?.dataset?.data;
  if (!String(data?.cashfree_order_id || data?.order_id || '').trim() ||
      typeof data?.payment_session_id !== 'string' || !data.payment_session_id.trim()) {
    throw new Error('The server did not return a valid Cashfree session.');
  }
  if (data.vk_order_id && data.vk_order_id !== orderId) throw new Error('Payment order does not match your purchase.');
  return data;
}
